export default __webpack_public_path__ + "static/media/sport.5d463693.webp";